import { STAND_STATUS, STATUS_REVERSE_CONVERTER } from 'utils/constants';

interface StatusProps {
  additionalClass?: string;
  children?: any;
  status: number;
}

const Status = ({
  additionalClass,
  children,
  status,
}: StatusProps) => (
  <div className={`status-${STATUS_REVERSE_CONVERTER[status]} ${additionalClass}`}>
    {typeof children !== 'undefined' ? children : STAND_STATUS[status]}
  </div>
);

export default Status;
